import { TrendItem } from "@/config/types/trend";
import { useEffect } from "react";
import Content from "./Content";
import Player, { I18N } from "xgplayer";
import ZH from "xgplayer/es/lang/zh-cn";
import "xgplayer/dist/index.min.css";
import "./VideoBox.less";

I18N.use(ZH);

interface VideoBoxProps {
  data: TrendItem;
  isAuditPage?: boolean; // 是否是审核页
}

const VideoBox = ({ data, isAuditPage }: VideoBoxProps) => {
  useEffect(() => {
    const player = new Player({
      lang: "zh",
      id: "video",
      url: data.files?.[0]?.url,
      height: "100%",
      width: "100%",
      domEventType: "touch",
      controls: {
        mode: "bottom",
        autoHide: false,
      },
      poster: {
        poster: data.files?.[0]?.smallUrl,
      },
      mobile: {
        gestureY: false,
      },
    });

    return () => player.destroy();
  }, []);

  return (
    <div className="video-box">
      <div id="video" className="video-source" onClick={(e: any) => e.stopPropagation()}></div>
      <Content theme="dark" data={data} isAuditPage={isAuditPage} />
    </div>
  );
};
export default VideoBox;
